import { Theme } from '@mui/material';

export const flowMixins: Theme['mixins'] = {
  toolbar: {
    minHeight: '64px',
  },
};
